import script from "./AIAssistantDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AIAssistantDialog.vue?vue&type=script&setup=true&lang=js"

import "./AIAssistantDialog.vue?vue&type=style&index=0&id=3203c6c4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3203c6c4"]])

export default __exports__